import { ACADEMIC_DECISIONS, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ListPendingDecisions from "./List";

export const resources = {
  isMenu: true,
  icon: <PendingActionsIcon />,
  name: `${StudentServicePath}${ACADEMIC_DECISIONS}/pending`,
  title: "Прекъсващи за слаб успех",
  list: <ListPendingDecisions />,
  permission: permissions.canPreviewAcademicDecisions,
};
